import { Component, OnDestroy, OnInit } from '@angular/core';
import { PrincipalService } from '@core/auth/principal.service';
import { BaseComponent } from '@app/shared/components/base-component';

@Component({
    selector: 'app-home',
    templateUrl: './nav-view.component.html',
    styleUrls: ['./nav-view.component.css'],
    standalone: false
})
export class NavViewComponent extends BaseComponent implements OnInit, OnDestroy {
    userName = 'Jacob Russell';
    data: any;

    constructor(
        protected principal: PrincipalService) {
            super();
        }

    ngOnInit() {}

    ngOnDestroy() {}
}